<template>
    <div class="row">
        <button type="button" class="btn btn-primary ml-2" data-toggle="modal" :data-target="'#vmbc_edit' + user.id"><i class="fa fa-edit"></i></button>

        <div :id="'vmbc_edit' + user.id" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"> {{user.first_name}} </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <input type="text" class="form-control" v-model="user.first_name">
                            </div>
                            <div class="col-md-6">
                                <input type="text" class="form-control" v-model="user.last_name">
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <model-select :options="Roles"
                                    v-model="user.Role"
                                    placeholder="select role">
                                </model-select>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <input type="email" v-model="user.email" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" @click="Save(user)"><i class="fa fa-save"></i></button>
                    </div>
                </div>

            </div>
</div>

    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        ModelSelect
    },
    props: ['user'],
    data() {
        return {
            // user: this.$root.id,
            Roles: [
                { value: 'Admin', text: 'Admin' },
                { value: 'Reception', text: 'Reception' },
                { value: 'Account', text: 'Account' },
                { value: 'Manager', text: 'Manager' },
                { value: 'Supervisor', text: 'Supervisor' },
                { value: 'Teacher', text: 'Teacher' },
                { value: 'User', text: 'User' },
            ],

        }
    },
    methods: {
        Save(user) {

            axios
            .post('./api/Admin/Users/update', {
                id: user.id,
                firstname: user.first_name,
                lastname: user.last_name,
                Role: user.Role,
                email: user.email
            })
            .then((result) => {
                console.log(result)
                 $('.modal').modal('hide');
            }).catch((err) => {
                console.log(err)
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Others/Admin/edit.vue